export const LOGIN = 'APP:LOGIN'
export const LOGOUT = 'APP:LOGOUT'
